import React from "react"
import { forwardRef } from "@design-system/core"
import { BadgeProps } from "./types"
import { BasicBadge } from "./BasicBadge"

export const Badge = forwardRef<BadgeProps, "div">((props, ref) => {
  return <BasicBadge {...props} variant="subtle" />
})
